// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c35edb97","247":"269dfba5","284":"47cbfc4a","422":"c6236b4f","627":"21dff5a0","768":"a71390dd","806":"c42855d1","834":"ce48a89e","923":"31e979b0","938":"2fb141cd"}[chunkId] + ".chunk.js";
};